<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import PaginationControl from '../PaginationControl/PaginationControl.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        PaginationControl,
        DropdownMenu,
        Fake
    },
    computed: {
        ...mapState({
            loading: state => state.allocation.allocations.loading,
            noContent: state => state.allocation.allocations.noContent,
            error: state => state.allocation.allocations.error,
            page: state => state.allocation.allocations.page,
            limitList: state => state.allocation.allocations.limitList,
            limit: state => state.allocation.allocations.limit,
            display: state => state.allocation.list.display,
            displayOptions: state => state.allocation.list.displayOptions
        }),
        ...mapGetters({
            filteredAllocationsPaginated: 'allocation/filteredAllocationsPaginated',
            filteredAllocationsMaxPages: 'allocation/filteredAllocationsMaxPages'
        })
    },
    methods: {
        ...mapActions({
            incrementAllocationPagination: 'allocation/incrementAllocationPagination',
            decrementAllocationPagination: 'allocation/decrementAllocationPagination',
            allocationListOptionSelect: 'allocation/allocationListOptionSelect',
            getAllocationList: 'allocation/getAllocationList',
            setLimit: 'allocation/setAllocationLimit'
        })
    }
}
</script>
<template>
    <div class="manage-allocation-list">
        <transition-group name="fade" mode="out-in">
            <div v-if="!loading"
                 :key="'body'"
                 class="manage-allocation-list__body">
                <div class="manage-allocation-list__header">
                    <div class="manage-allocation-list__heading">
                        {{ $t('manageAllocationList.header') }}
                    </div>
                    <div class="manage-allocation-list__option manage-allocation-list__option--pagination">
                        <pagination-control :max-pages="filteredAllocationsMaxPages"
                                            :current-page="page"
                                            @prev="decrementAllocationPagination"
                                            @next="incrementAllocationPagination"/>
                    </div>
                    <div class="manage-allocation-list__option">
                        <dropdown-menu
                            :value="limit"
                            :items="limitList"
                            :label="$t('bookingList.perPage')"
                            :searchable="false"
                            @input="setLimit($event)"/>
                    </div>
                    <div class="manage-allocation-list__option">
                        <dropdown-menu
                            :value="display"
                            :items="displayOptions"
                            :translation-prefix="'bookingList.display'"
                            :label="$t('bookingList.display.label')"
                            :searchable="false"
                            @input="allocationListOptionSelect($event)"/>
                    </div>
                </div>
                <table class="manage-allocation-list__table">
                    <thead>
                        <tr>
                            <th>{{ $t('manageAllocationList.list.from') }}</th>
                            <th>{{ $t('manageAllocationList.list.to') }}</th>
                            <th>{{ $t('manageAllocationList.list.type') }}</th>
                            <th>{{ $t('manageAllocationList.list.units') }}</th>
                            <th>{{ $t('manageAllocationList.list.releaseType') }}</th>
                            <th>{{ $t('manageAllocationList.list.releaseDays') }}</th>
                            <th>{{ $t('manageAllocationList.list.releaseDate') }}</th>
                            <th>{{ $t('manageAllocationList.list.updatedAt') }}</th>
                            <th>{{ $t('manageAllocationList.list.updatedBy') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(allocation, index) in filteredAllocationsPaginated" :key="index">
                            <td>{{ allocation.from | moment("DD/MM/YYYY") }}</td>
                            <td>{{ allocation.to | moment("DD/MM/YYYY") }}</td>
                            <td>{{ allocation.type }}</td>
                            <td>{{ allocation.units }}</td>
                            <td>{{ allocation.releaseType }}</td>
                            <td>{{ allocation.releaseDays }}</td>
                            <td>
                                <span v-if="allocation.releaseDate">
                                    {{ allocation.releaseDate | moment("DD/MM/YYYY") }}
                                </span>
                            </td>
                            <td>{{ allocation.updatedAt | moment("DD/MM/Y\, HH:mm") }}</td>
                            <td>
                                <span>
                                    {{ allocation.userName }}
                                </span>
                                <span v-if="allocation.comment">
                                    <i :title="allocation.comment" class="fa fa-fw fa-info"/>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!loading && !error && (noContent || !filteredAllocationsPaginated.length)"
                     :key="'no-content'"
                     class="manage-allocation-list__error">
                    <i class="fa fa-bullhorn"/>
                    <div class="manage-allocation-list__error-message">
                        {{ $t('manageAllocationList.noAllocations') }}
                    </div>
                </div>
                <div v-if="!loading && error"
                     :key="'error'"
                     class="manage-allocation-list__error">
                    <i class="fa fa-exclamation-circle"/>
                    <div class="manage-allocation-list__error-message">
                        {{ $t('manageAllocationList.error') }}
                    </div>
                    <div class="manage-allocation-list__error-retry" @click="getAllocationList">
                        {{ $t('manageAllocationList.retry') }}
                    </div>
                </div>
                <div class="manage-allocation-list__footer">
                    <div v-if="!loading" class="manage-allocation-list__pagination">
                        <pagination-control :max-pages="filteredAllocationsMaxPages"
                                            :current-page="page"
                                            @prev="decrementAllocationPagination"
                                            @next="incrementAllocationPagination"/>
                    </div>
                </div>
            </div>
            <fake v-if="loading"
                  :header-rows="1"
                  :body-rows="10"
                  :body-cells="4"
                  :key="'fake'"/>
        </transition-group>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationList/ManageAllocationList.vue